import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { EmployeeNotifications } from '@/experiences/sales-portal/domain/accounts/screens/employee-list/types';
import { ToggleRow } from '@/experiences/sales-portal/domain/accounts/screens/employee-list/containers/employee-edit-panel/components/toggle-row';
import { Typography } from '@usepepper/sprout-kit-ui';
import { useUpdateEmployeeNotificationsMutator } from '@/experiences/sales-portal/domain/accounts/screens/employee-list/containers/employee-notifications-section/blocs/mutators/use-update-employee-notifications-mutator';
import { View } from 'react-native';

interface EmployeeNotificationsSectionProps {
  notifications: EmployeeNotifications;
}

export const EmployeeNotificationsSection: React.FC<
  EmployeeNotificationsSectionProps
> = ({ notifications }) => {
  const [styles] = useStyles();

  const {
    notifications: localNotifications,
    onChange,
    pendingField,
  } = useUpdateEmployeeNotificationsMutator(notifications);

  return (
    <View style={styles.container}>
      <Typography accessibilityRole="header" bold size="$md">
        {i18n.t('sales_portal.employee_edit_drawer.notifications.push_title')}
      </Typography>
      <View style={styles.section}>
        <ToggleRow
          checked={localNotifications.wants_order_tracking_notification}
          disabled={pendingField === 'wants_order_tracking_notification'}
          onCheckedChange={(value) =>
            onChange('wants_order_tracking_notification', value)
          }
          title={i18n.t(
            'sales_portal.employee_edit_drawer.notifications.order_tracking',
          )}
        />
      </View>
      <Typography accessibilityRole="header" bold size="$md">
        {i18n.t('sales_portal.employee_edit_drawer.notifications.email_title')}
      </Typography>
      <View style={styles.section}>
        <ToggleRow
          checked={localNotifications.wants_order_email}
          disabled={pendingField === 'wants_order_email'}
          onCheckedChange={(value) => onChange('wants_order_email', value)}
          title={i18n.t(
            'sales_portal.employee_edit_drawer.notifications.order_confirmation',
          )}
        />
        <ToggleRow
          checked={localNotifications.wants_chat_email}
          disabled={pendingField === 'wants_chat_email'}
          onCheckedChange={(value) => onChange('wants_chat_email', value)}
          title={i18n.t(
            'sales_portal.employee_edit_drawer.notifications.new_chat_messages',
          )}
        />
        <ToggleRow
          checked={localNotifications.wants_payment_email}
          disabled={pendingField === 'wants_payment_email'}
          onCheckedChange={(value) => onChange('wants_payment_email', value)}
          title={i18n.t(
            'sales_portal.employee_edit_drawer.notifications.payments',
          )}
        />
        <ToggleRow
          checked={localNotifications.wants_credit_request_email}
          disabled={pendingField === 'wants_credit_request_email'}
          onCheckedChange={(value) =>
            onChange('wants_credit_request_email', value)
          }
          title={i18n.t(
            'sales_portal.employee_edit_drawer.notifications.new_credit_requests',
          )}
        />
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    gap: theme.sk.spacing.spaceMedium,
    width: '100%',
  },
  section: {
    gap: theme.sk.spacing.spaceSMedium,
    width: '100%',
  },
}));
